<template>
    <v-row dense justify="center" class="StatisticsCommerce pa-6">
        <!-- Aller bosse maintenant ! -->
    </v-row>
</template>

<script>
export default {
    name: "StatisticsCommerce",
    components: {

    },
    data() {
        return {
            
        }
    },
    destroyed() {
        
    },
    methods: {

    },
    created() {
        
    },
}
</script>

<style lang="scss">
    .StatisticsCommerce {

    }
</style>